var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"upperLine"},[_vm._v(_vm._s(_vm.field1))]),_c('div',{staticClass:"lowerLine"},[_vm._v(_vm._s(_vm.field2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }